import React, { FC, ChangeEvent } from 'react'
import { useId } from '@reach/auto-id'
import cx from 'classnames'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import styles from './TextArea.module.scss'

type TextAreaProps = {
  defaultValue?: string | number
  name: string
  value?: string | number
  label: string
  error?: string
  required?: boolean
  disabled?: boolean
  rows?: number
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void
}

export const TextArea: FC<TextAreaProps> = ({ value, label, rows = 3, error, ...rest }) => {
  const textAreaId = useId()
  const textAreaStyles = cx({
    [styles.textArea]: true,
    [styles.filled]: value,
    [styles.errored]: error,
  })

  return (
    <div className={textAreaStyles}>
      <textarea id={textAreaId} rows={rows} value={value} {...rest} />

      <label htmlFor={textAreaId} className={styles.label}>
        {label}
      </label>

      {error ? (
        <Text size="xsmall" className={styles.error}>
          <Icon name="alert-line" size="lg" /> {error}
        </Text>
      ) : null}
    </div>
  )
}

TextArea.displayName = 'TextArea'
